<app-header [forceLightBackground]="true"></app-header>
<div class="admin-activities">
  <div class="admin-activities--layout">
    <app-admin-sidebar class="admin-activities--sidebar"></app-admin-sidebar>
    <div class="admin-activities--content">
      <app-page-header></app-page-header>
      <app-activities [showTabs]="true" [hideComputeTab]="true"></app-activities>
    </div>
  </div>
</div>


